import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateSuspendedSubscriptionSettingParams {
  user: string;
  enabled: boolean;
}

export class UpdateSuspendedSubscriptionSettingRequest extends Request<IUpdateSuspendedSubscriptionSettingParams, IResult> {
  constructor(params: IUpdateSuspendedSubscriptionSettingParams) {
    super('updateSuspendedSubscriptionNotificationSetting', params);
  }
}
